<template>
  <b-modal v-model="isShow" size="md" title="Điều chỉnh chính sách" v-b-modal.modal-scrollable>
    <h6>Chính sách mới</h6>
    <Select2 v-model="polycyId" :options="options" placeholder="Chọn chính sách" />
    <template #modal-footer="{ hide }">
      <b-button variant="outline-danger" @click="hide()"> Huỷ bỏ </b-button>
      <b-button variant="outline-primary" @click="submit"> Xác nhận </b-button>
    </template>
    <VueLoadingOverlay :active.sync="isLoading"> </VueLoadingOverlay>
  </b-modal>
</template>

<script>
  import { DeviceService } from '@/services/device.service'

  export default {
    name: 'PopupRentConfirm',
    props: {
      id: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        isShow: false,
        polycyId: '',
        options: [],
      }
    },

    methods: {
      async submit() {
        try {
          this.isLoading = true
          const res = await DeviceService.changePolicy({
            id: this.id,
            policyid: this.polycyId,
          })
          if (res.code === 1000) {
            this.$emit('success')
            this.isShow = false
          } else {
            this.showFailMx(res.message)
          }
        } catch (e) {
          this.showFailMx(e.message)
        } finally {
          this.isLoading = false
        }
      },

      async loadData() {
        if (this.options.length > 0) return
        try {
          this.isLoading = true
          const res = await DeviceService.fetchPolicyDevice({
            limit: 20,
            page: 1,
          })
          if (res.code === 1000) {
            this.options = res.data.map(item => {
              return {
                id: item.id,
                text: item.name,
              }
            })
          } else {
            this.showFailMx(res.message)
          }
        } catch (e) {
          this.showFailMx(e.message)
        } finally {
          this.isLoading = false
        }
      },

      async show(polycyId) {
        this.isShow = true
        await this.loadData()
        this.polycyId = polycyId
      },
    },
  }
</script>

<style scoped></style>
